import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Picture from '../components/Picture';
import logo from '../assets/images/logoFree.webp';
import logoFallback from '../assets/images/logoFree.png';
import { setAdminKey } from '../utils/adminAuth';
import '../styles/AdminLogsPage.css';

function AdminLoginPage() {
    const [inputKey, setInputKey] = useState('');
    const location = useLocation();
    const navigate = useNavigate();
    const fallbackPath = '/admin-analytics';
    const target = location.state?.from?.pathname || fallbackPath;

    const handleSubmit = (event) => {
        event.preventDefault();
        const trimmed = inputKey.trim();
        if (!trimmed) {
            return;
        }
        setAdminKey(trimmed);
        navigate(target, { replace: true });
    };

    return (
        <div className='page admin-auth-page'>
            <main className='admin-auth-main'>
                <div className='admin-auth-card'>
                    <div className='admin-auth-brand'>
                        <Picture
                            webpSrc={logo}
                            fallbackSrc={logoFallback}
                            alt='MAF Industries'
                            className='admin-auth-logo'
                            imgClassName='admin-auth-logo-img'
                        />
                        <div>
                            <span className='admin-auth-title'>MAF Industries</span>
                            <span className='admin-auth-subtitle'>
                                Admin espace partagé
                            </span>
                        </div>
                    </div>
                    <p className='admin-auth-note'>
                        Saisis ta clé admin une fois pour accéder aux stats, aux avis,
                        aux produits et aux cartes réalisables.
                    </p>
                    <form onSubmit={handleSubmit}>
                        <div className='admin-auth-field'>
                            <input
                                type='password'
                                value={inputKey}
                                onChange={(event) => setInputKey(event.target.value)}
                                placeholder='Clé admin'
                                aria-label='Clé admin'
                            />
                            <button type='submit' className='button'>
                                Se connecter
                            </button>
                        </div>
                    </form>
                </div>
            </main>
        </div>
    );
}

export default AdminLoginPage;
